<template>
    <div :class="['col-xs-12', `col-md-${size}`]">
        <form-group-search-select-multiple 
            v-if="disciplinas" 
            ref="input" 
            :label="label" 
            :readonly="readonly" 
            :value="value"
            :name="name" 
            :options="disciplinas" 
            :data-vv-as="label" 
            :placeholder="placeholder"
            @input="$emit('input', $event)" 
            @change="$emit('input', $event)" 
            v-validate="{ required: required }"
        />
    </div>
</template>
  
<script>
import MatriculaService from "../../../../domain/corpore/MatriculaService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
    name: "c-protocolo-disciplinas-ativas-multiplas",
    $_veeValidate: {
        validator: "new"
    },
    inject: ["$validator", "formValues"],
    props: {
        label: String,
        id: String,
        name: {
            required: true,
            type: String
        },
        size: {
            type: String,
            default: "6"
        },
        disabled: Boolean,
        placeholder: String,
        readonly: Boolean,
        value: Array,
        required: Boolean,
        cursoId: null,
        login: {
            type: String,
            default: ""
        }
    },
    computed: {
        usuario() {
            return this.$store.state.usuario;
        }
    },
    mounted() {
        this.$el.value = this.value;
    },
    asyncComputed: {
        disciplinas() {
            const matriculaService = new MatriculaService(this.$http);
            let login = this.login != "" ? this.login : this.usuario.login;
            return matriculaService
                .getDisciplinasMatricula(login)
                .then(result => {
                    return result.map(disciplina => ({
                        value: disciplina.CODDISC,
                        text: disciplina.DISCIPLINA
                    }));
                })
                .catch(err => {
                    SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DisciplinasAtivasMultiplas.vue